export default class BillingCtrl {
    constructor ($order) {
        "ngInject";
        this.order = $order;
    }

}



// WEBPACK FOOTER //
// ./src/app/orders/billing.ctrls.js